import React, { useState, useEffect } from "react";
import { Form, Col } from "react-bootstrap";
import { InputField } from '../../../../components/InputField';
import FormatJiraHour from '../../../../../../utils/FormatJiraHour';
import { MonthList } from '../../../../../../utils/CycleList';
import "react-datepicker/dist/react-datepicker.css";
import { HandleGetDateSelect } from './utils/HandleGetDateSelect';
import IsValidTotalHours from "../../../../../../utils/validators/IsValidTotalHours";
import { ActivityModal } from "./component/Modal";

export const TimerFactory = ({ handleDates, reload, professionals, cliente, cycleDay, modalOptions }) => {
  const year = new Date().getFullYear();
  const currentDay = new Date();

  const [initialCycleDay, setInitialCycleDay] = useState(20);
  const [totalHours, setTotalHours] = useState('');
  const [professionalFactory, setProfessionalFactory] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [idRFQ, setIdRFQ] = useState(0);

  const [billingMonth, setBillingMonth] = useState(currentDay.getDate() >= initialCycleDay
    ? currentDay.getMonth() + 1
    : currentDay.getMonth()
  );

  const handleAllocationChange = (e) => {
    const findIdBusinessValue = professionals.length > 0 &&
      professionals.find(x => x.idUser === Number(e.target.value));

    if(e.target.value > 0 && e.target.value !== professionalFactory) {
      setIdRFQ(findIdBusinessValue?.idBusinessProposalValue);
      setProfessionalFactory(e.target.value);
      setModalOpen(true);
    }
  }

  useEffect(() => {
    if (cycleDay) {
      setInitialCycleDay(cycleDay);
    }
  }, [cycleDay])

  useEffect(() => {
    if (totalHours &&
      professionalFactory &&
      billingMonth &&
      idRFQ) {
      handleDates(totalHours, professionalFactory, billingMonth, idRFQ);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalHours, professionalFactory, billingMonth, idRFQ]);

  useEffect(() => {
    if (reload) {
      setTotalHours('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <>
      <Form.Row>
        <Form.Group as={Col} lg="2" xs="12">
          <InputField
            type="text"
            name="totalTimer"
            label="Horas Totais"
            placeholder="Ex.: 160h20m"
            value={FormatJiraHour(totalHours)}
            onChange={(e) => setTotalHours(FormatJiraHour(e.target.value))}
            maxLength={7}
            isInvalid={totalHours && !IsValidTotalHours(totalHours)}
            required
          />
        </Form.Group>

        <Form.Group as={Col} lg="6" xs="12">
          <InputField
            as="select"
            name="professionalFactory"
            label="Profissional"
            value={professionalFactory}
            onChange={(e) => handleAllocationChange(e)}
            className={cliente?.length === 0 ? "fade" : null}
            disabled={cliente?.length === 0}
            required
          >
            <option value="">Selecione o profissional</option>
            {professionals.length &&
              professionals.map((professional, index) => (
                <option key={index} value={professional.idUser}>
                  {professional.inexEnrollment + ' - ' + professional.name}
                </option>
              )
              )}
          </InputField>
        </Form.Group>

        <Form.Group as={Col} lg="4" xs="12">
          <InputField
            as="select"
            name="factoryDay"
            label="Mês de Faturamento"
            value={billingMonth}
            onChange={(e) => setBillingMonth(e.target.value)}
            className={cliente?.length === 0 ? "fade" : null}
            disabled={cliente?.length === 0}
            required
          >
            <option value="">Selecione o mês</option>
            {MonthList?.length > 0 &&
              MonthList.map((date, index) => (
                <option key={index} value={date.value}>
                  {HandleGetDateSelect(date.name, date.value, initialCycleDay, year)}
                </option>
              )
              )}
          </InputField>
        </Form.Group>
      </Form.Row>

      <ActivityModal
        open={modalOpen}
        close={() => setModalOpen(false)}
        options={modalOptions}
        text="Selecione abaixo a atividade desse profissional"
        idRFQ={idRFQ}
        handleConfirm={setIdRFQ}
      />
    </>
  );
};
